import { render, staticRenderFns } from "./DisplayFilter.vue?vue&type=template&id=3c037afc&scoped=true&"
import script from "./DisplayFilter.vue?vue&type=script&lang=js&"
export * from "./DisplayFilter.vue?vue&type=script&lang=js&"
import style0 from "./DisplayFilter.vue?vue&type=style&index=0&id=3c037afc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c037afc",
  null
  
)

export default component.exports